import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import { TrendingUpOutlined } from '@material-ui/icons';

const Search = ({ visible, meta, setMeta }) => {
    const defaultInputRef = useRef(null);
    const profile = useSelector(state => state.profile.profile);
    const orders = useSelector(state => state.orders.createShipment);
    const [searchButtonDisabled, setSearchButtonDisabled] = useState(true)
    const [switchStatus, setSwitchStatus] = React.useState(false);
    const [userInteracted, setUserInteracted] = useState(false);
    const [formValues, setFormValues] = useState(meta)
    
    const onInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues({
            ...formValues,
            [name]: value
        });
    };

    const checkFormHasValues = () => {
        let disableButton = true
        if (formValues["sku"] != "" || formValues["tracking_number"] != "" || formValues["customer_name"] != "" || formValues["order_id"] != ""
            || formValues["goods_out_note"] != "" || formValues["reference_no"] != "" || formValues["receiver_province"] != "" || formValues["receiver_country_code"] != "" 
        || formValues["quantity"] != "") {
            disableButton = false
        }

        return disableButton
    }

    const handleKeyUp = (event) => {
        if (event.keyCode === 13) {
            submitSearchValues();
        }
    }

    const submitSearchValues = () => {
        setMeta(prevState => ({
            ...prevState,
            [`sku`]: formValues["sku"],
            [`quantity`]: formValues["quantity"],
            [`order_id`]: formValues["order_id"],
            [`tracking_number`]: formValues["tracking_number"],
            [`customer_name`]: formValues["customer_name"],
            [`goods_out_note`]: formValues["goods_out_note"],
            [`reference_no`]: formValues["reference_no"],
            [`receiver_province`]: formValues["receiver_province"],
            [`receiver_country_code`]: formValues["receiver_country_code"],
            [`page`]: 1
        }));
    }

    const resetFields = () => {
        setFormValues({
            ...formValues,
            [`sku`]: "",
            [`quantity`]: "",
            [`order_id`]: "",
            [`tracking_number`]: "",
            [`customer_name`]: "",
            [`page`]: 1,
            [`reference_no`]: "",
            [`goods_out_note`]: "",
            [`receiver_province`]: "",
            [`receiver_country_code`]: ""
        });
        setMeta(prevState => ({
            ...prevState,
            [`sku`]: "",
            [`quantity`]: "",
            [`order_id`]: "",
            [`tracking_number`]: "",
            [`customer_name`]: "",
            [`page`]: 1,
            [`reference_no`]: "",
            [`goods_out_note`]: "",
            [`receiver_province`]: "",
            [`receiver_country_code`]: ""
        }));
    }

    const onInputClear = (name) => {
        setFormValues({
            ...formValues,
            [name]: "",
        });
        setMeta(prevState => ({
            ...prevState,
            [name]: ""
        }));
    };

    const onChangeSwitch = (switchValue) => {
        setSwitchStatus(switchValue)
        setMeta({
            ...meta,
            [`auto_label_generate`]: switchValue
        });
    }

    useEffect(() => {
        setSearchButtonDisabled(checkFormHasValues())
    }, [formValues])

    useEffect(() => {
        if (profile && profile.auto_label_generate && profile.auto_label_generate===true) {
            setSwitchStatus(true)
        }
    }, [profile])

    const handleFocus = (isDefault) => {
        if (!isDefault) {
          setUserInteracted(true); // Stop focusing default input if user clicks another input
        }
      };
     useEffect(() => {
        // Set default focus only on component mount
        if (visible && defaultInputRef.current && !userInteracted) {
          defaultInputRef.current.focus();
        }
      }, [visible,userInteracted]);

      useEffect(() => {
        if (orders && orders.notification && orders.notification.messageContent
            && orders.notification.messageContent[0] === 'Shipment Created Successfully' ) {
            resetFields()
        }
    }, [orders]);



    return (
        <>
            {visible &&
                <div className="filtercontainer">
                    <div className="filteraccordion" onKeyUp={handleKeyUp}>
                        <Box
                            component="form"
                            sx={{
                                '& > :not(style)': { m: 1, width: '20ch' },
                            }}

                            noValidate
                            autoComplete="off"
                            onSubmit={e => { e.preventDefault(); }}
                        >
                            <TextField
                                value={formValues && formValues.goods_out_note}
                                name={"goods_out_note"}
                                label="Scan Goods Out Note"
                                size={'small'}
                                onChange={onInputChange}
                                InputProps={{
                                    endAdornment: (formValues && formValues.goods_out_note) ? (
                                        <IconButton size="small" onClick={() => onInputClear("goods_out_note")}>
                                            <ClearIcon />
                                        </IconButton>
                                    ) : undefined
                                }}
                                variant="standard"
                            />
                            <TextField
                                value={formValues && formValues.order_id}
                                name={"order_id"}
                                label="Order Number"
                                size={'small'}
                                onChange={onInputChange}
                                inputRef={defaultInputRef}
                                onFocus={() => handleFocus(true)}
                                onKeyUp={(event) => {
                                    if (event.key == "Enter") submitSearchValues()
                                  }}
                                InputProps={{
                                    endAdornment: (formValues && formValues.order_id) ? (
                                        <IconButton size="small" onClick={() => onInputClear("order_id")}>
                                            <ClearIcon />
                                        </IconButton>
                                    ) : undefined
                                }}
                                variant="standard"
                            />
                            <TextField
                                value={formValues && formValues.tracking_number}
                                name={"tracking_number"}
                                label="Tracking Number"
                                size={'small'}
                                onChange={onInputChange}
                                InputProps={{
                                    endAdornment: (formValues && formValues.tracking_number) ? (
                                        <IconButton size="small" onClick={() => onInputClear("tracking_number")}>
                                            <ClearIcon />
                                        </IconButton>
                                    ) : undefined
                                }}
                                variant="standard"
                            />
                            <TextField
                                value={formValues && formValues.customer_name}
                                name={"customer_name"}
                                label="Customer Name"
                                size={'small'}
                                onChange={onInputChange}
                                InputProps={{
                                    endAdornment: (formValues && formValues.customer_name) ? (
                                        <IconButton size="small" onClick={() => onInputClear("customer_name")}>
                                            <ClearIcon />
                                        </IconButton>
                                    ) : undefined
                                }}
                                variant="standard"
                            />
                            <TextField
                                value={formValues && formValues.reference_no}
                                name={"reference_no"}
                                label="Reference Number"
                                size={'small'}
                                onChange={onInputChange}
                                InputProps={{
                                    endAdornment: (formValues && formValues.reference_no) ? (
                                        <IconButton size="small" onClick={() => onInputClear("reference_no")}>
                                            <ClearIcon />
                                        </IconButton>
                                    ) : undefined
                                }}
                                variant="standard"
                            />
                            <TextField
                                value={formValues && formValues.receiver_province}
                                name={"receiver_province"}
                                label="Receiver Province Code"
                                size={'small'}
                                onChange={onInputChange}
                                InputProps={{
                                    endAdornment: (formValues && formValues.receiver_province) ? (
                                        <IconButton size="small" onClick={() => onInputClear("receiver_province")}>
                                            <ClearIcon />
                                        </IconButton>
                                    ) : undefined
                                }}
                                variant="standard"
                            />
                            <TextField
                                value={formValues && formValues.receiver_country_code}
                                name={"receiver_country_code"}
                                label="Receiver Country Code"
                                size={'small'}
                                onChange={onInputChange}
                                InputProps={{
                                    endAdornment: (formValues && formValues.receiver_country_code) ? (
                                        <IconButton size="small" onClick={() => onInputClear("receiver_country_code")}>
                                            <ClearIcon />
                                        </IconButton>
                                    ) : undefined
                                }}
                                variant="standard"
                            />
                            <TextField
                                value={formValues && formValues.sku}
                                name={"sku"}
                                label="SKU"
                                size={'small'}
                                onChange={onInputChange}
                                InputProps={{
                                    endAdornment: (formValues && formValues.sku) ? (
                                        <IconButton size="small" onClick={() => onInputClear("sku")}>
                                            <ClearIcon />
                                        </IconButton>
                                    ) : undefined
                                }}
                                variant="standard"
                            />
                            <TextField
                                value={formValues && formValues.quantity}
                                name={"quantity"}
                                label="Quantity"
                                size={'small'}
                                onChange={onInputChange}
                                InputProps={{
                                    endAdornment: (formValues && formValues.quantity) ? (
                                        <IconButton size="small" onClick={() => onInputClear("quantity")}>
                                            <ClearIcon />
                                        </IconButton>
                                    ) : undefined
                                }}
                                variant="standard"
                            />
                              <FormControl style={{paddingTop:'15px'}} variant="standard" sx={{ m: 1, minWidth: 200 }}>
                                <FormControlLabel
                                    style={{fontSize: '14px !important'}}
                                    control={
                                        <Switch
                                            color="primary"
                                            defaultChecked={switchStatus}
                                            checked={switchStatus}
                                            onChange={(e) => {
                                                onChangeSwitch(e.target.checked)
                                            }}
                                            size="small"
                                            name="auto_label_generate" />
                                    }
                                    label={
                                        <Typography style={{ fontSize: '14px' }}>
                                            Auto Label Generate
                                        </Typography>}
                                    labelPlacement="end"
                                />
                            </FormControl>
                        </Box>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={12}>
                                <div className="filterfooter">
                                    <Button variant="contained" onClick={submitSearchValues} disabled={searchButtonDisabled}>Search</Button>
                                    <Button variant="outlined" onClick={resetFields} disabled={searchButtonDisabled}>Clear</Button>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            }
        </>
    )

}

export default Search;
